
<ng-template cdk-portal>
  <div class="process-button-container">
    <lib-button
      id="back-to-processes-button"
      [label]="('PLANNING.OVERVIEW.BACK_TO' |translate) + ' ' + ('PLANNING.OVERVIEW.PROCESS' |translate)"
      color="secondary"
      [faIcon]="'far fa-arrow-left'"
      (buttonClicked)="backToAll()" >
    </lib-button>
  </div>
</ng-template>

<div class="row">
  <div class="col-12 mb-3">
    <lib-fixed-time-range-selection
      [title]="'COMPONENT_LIBRARY.TIME_SELECTION.TITLE'"
      [themeService]="themeService"
    ></lib-fixed-time-range-selection>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-3">
    <div class="card shadow-sm">
      <div class="card-header">
        <div class="d-flex font-weight-bold text-primary font-size-normal mr-auto">
          {{ 'KPI.COMMON.SUMMARY' | translate }}
        </div>
      </div>
      <div class="card-body p-0">
        @if (loading) {
          <app-loading-and-no-data-template
            [isLoading]="loading"
            [height]="100"
          ></app-loading-and-no-data-template>
        } @else {
          <div class="row p-2 d-flex align-items-center justify-content-between">
            <div class="col-12 col-sm-6 col-md-auto p-3">
              <div class="text-primary font-weight-bold font-size-medium text-center">
                {{ selectedProcess?.durationPlanned | duration:true:'seconds' }}
              </div>
              <div class="text-center">{{ 'KPI.PORTFOLIO.PROCESSES_LIST_TABLE.DURATION_PLANNED' | translate }}</div>
            </div>
            <div class="col-12 col-sm-6 col-md-auto p-3">
              <div class="text-primary font-weight-bold font-size-medium text-center">
                {{ selectedProcess?.durationRealized | duration:true:'seconds' }}
              </div>
              <div class="text-center">{{ 'KPI.PORTFOLIO.PROCESSES_LIST_TABLE.DURATION_REALIZED' | translate }}</div>
            </div>
            <div class="col-12 col-sm-6 col-md-auto p-3">
              <div class="font-weight-bold font-size-medium text-center"
                   [ngStyle]="{'color': selectedProcess?.durationDeviation <= 0 ? 'var(--green)' : 'var(--red)'}">
                {{ selectedProcess?.durationDeviation === 0 ? '' : selectedProcess?.durationDeviation < 0 ? '-' : '+' }}
                {{ selectedProcess?.durationDeviation | duration:true:'seconds' }}
              </div>
              <div class="text-center">{{ 'KPI.PORTFOLIO.PROCESSES_LIST_TABLE.DURATION_DEVIATION' | translate }}</div>
            </div>
            <div class="col-12 col-sm-6 col-md-auto p-3">
              <div class="text-primary font-weight-bold font-size-medium text-center">
                {{ selectedProcess?.productionLossRealized | number:'1.0-0' | customNumberFormat }} kWh
              </div>
              <div class="text-center">{{ 'KPI.PORTFOLIO.PROCESSES_LIST_TABLE.PROD_LOSS_REALIZED' | translate }}</div>
            </div>
            <div class="col-12 col-sm-6 col-md-auto p-3">
              <div class="text-primary font-weight-bold font-size-medium text-center">
                {{ selectedProcess?.revenueLossRealized | number:'1.0-0' | customNumberFormat }} {{ ''|currencyPortfolio }}
              </div>
              <div class="text-center">{{ 'KPI.PORTFOLIO.PROCESSES_LIST_TABLE.REV_LOSS_REALIZED' | translate }}</div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 p-3 process-details-block">
    @if (!loading) {
      <mat-tab-group [(selectedIndex)]="selectedIndex">
        <mat-tab>
          <ng-template mat-tab-label>
            {{ 'KPI.PORTFOLIO.PROCESSES_LIST_TABLE.T_CLASS_BLOCKS' | translate }}
            <mat-chip
              class="rounded ml-2 font-size-small justify-content-center">
              {{ eventsAndTClassBlocks?.tClassBlocks?.length || 0 }}
            </mat-chip>
          </ng-template>
          <app-kpi-t-class-blocks-list-table
            [tClassBlocks]="eventsAndTClassBlocks?.tClassBlocks"
            [isProcessUnassigning]="isProcessUnassigning"
            [displayActionColumn]="selectedProcess?.status === 1"
            (optionSelected)="optionSelectedBlocksFunc($event)"
          ></app-kpi-t-class-blocks-list-table>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            {{ 'KPI.PORTFOLIO.PROCESSES_LIST_TABLE.PLANNED_EVENTS' | translate }}
            <mat-chip
              class="rounded ml-2 font-size-small justify-content-center">
              {{ eventsAndTClassBlocks?.plannedEvents?.length || 0 }}
            </mat-chip>
          </ng-template>
          <app-kpi-planned-events-list-table
            [events]="eventsAndTClassBlocks?.plannedEvents"
            [isProcessUnassigning]="isProcessUnassigning"
            [displayActionColumn]="true"
            (optionSelected)="optionSelectedEventsFunc($event)"
          ></app-kpi-planned-events-list-table>
        </mat-tab>
      </mat-tab-group>
    }
  </div>
</div>

<div class="row col-12 mt-3" >
  <lib-card [overflow]="false" class="w-100" [fullScreenMode]="true" (fullScreenChange)="scheduleFullScreen = $event" [fullHeight]="true">

    <lib-card-header>
      <ul class="nav d-flex align-items-center pb-1">
        <li class="nav-item font-weight-bold text-primary font-size-normal mr-auto">
          {{'KPI.COMMON.SCHEDULE' |translate}}
        </li>
      </ul>
    </lib-card-header>

    <lib-card-body>
      <div [ngClass]="scheduleFullScreen ? 'h-100' : 'schedule'" class="mt-2">
        <app-kpi-process-analytics-schedule-chart
          [endRange]="(timeRange | async).endTS"
          [startRange]="(timeRange | async).startTS"
          [queryService]="processDetailScheduleService"
          [plannedEventsIds]="plannedEventsIds"
          [tClassBlocksIds]="tClassBlocksIds"
          [processStartEnd]="processStartEnd"
        ></app-kpi-process-analytics-schedule-chart>
      </div>
    </lib-card-body>

  </lib-card>
</div>
